import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/analytics.template.htm';
import Statistics_selector_template from 'text-loader!../templates/analytics/analytics_queues_users_template.html';
import 'dhtmlxMessage';
import QueuesStatisticsCollection from '../models/queues_statistics.paginated.collection.ts';
import VenuesCollection from '../models/venues.paginated.collection.ts';
import '../../libs/amcharts/amcharts.js';
import '../../libs/amcharts/serial.js';
import 'jqueryUI';
import 'jqueryUIDatePickerEnglish';
import 'jqueryUIDatePickerGreek';
import i18n  from "l10n";
import colors from '../../libs/assets/colors.js';

import StatisticsSelectorView from './analytics/statistics_selector_view.ts';
import QueueStatisticsView from './analytics/venue/queues/analytics_queues_statistics.view.ts';
import UsersStatisticsView from './analytics/venue/users/analytics_users_statistics.view.ts';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	statistics_selector_template: Handlebars.compile(Statistics_selector_template),
	superInitialize: GenericView.prototype.initialize,
	options: [],
	from: $.datepicker.formatDate('yy-mm-dd', new Date()),
	to: $.datepicker.formatDate('yy-mm-dd', new Date()),
	initialize: function () {
	    var self = this;

	    this.venues_collection = new VenuesCollection();
        this.loadVenues();
	},
	superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();

        var dataToDisplay = this.venues_collection.models.length == 0
            ? $("<div style='font-size: 1.6em; font-weight: bold;'>"+ i18n.t('analytics.no_venues_to_display') +"</div>").html()
            : this.template( { "venues" : this.venues_collection.models } )

        this.$el.html(dataToDisplay);

        return this;
    },
    events:{
        "click #filterForDates": "filterForDates",
        "change #selectVenue": "changeTabSelect"
    },
	loadVenues: function()
	{
	    var self = this;

        this.venues_collection.url = 'rest/api/venues';
        this.venues_collection.on( 'sync', this.successVenuesData, this );
        this.venues_collection.on( 'error', this.errorVenuesData, this );
        this.venues_collection.getFirstPage();
	},
	successVenuesData: function(response)
    {
    	this.render();

    	if(this.venues_collection.models.length > 0) {
            var model = this.venues_collection.models[0].attributes;
            this.$el.find("#selectVenue").val(model.id).trigger("change");
    	}
    },
    errorVenuesData: function(venues_collection, xhr, options)
    {
    	this.onErrorHandler(venues_collection, xhr, options);
    },
    filterForDates: function() {
        this.$el.find("#statistics-container").html('<i class="fas fa-circle-notch myprogress fa-5x"></i>'); // clear currently shown stats

        var selection = this.statSelectorView.selection;
        var venueId = this.statSelectorView.venueId;

        var datesFilter = this.statSelectorView.analyticsDatePickerView.getDates();
        var from = datesFilter ? datesFilter.from : null;
        var to = datesFilter ? datesFilter.to : null;

        if(!from || !to) {
            // todo: Show wrong dates message
            return;
        }

        if(selection == "Queues") {
            this.queueStatsView = new QueueStatisticsView({"venueId": venueId, "from": from, "to": to});
            this.queueStatsView.loadData();
        }
        else if(selection == "Users") {
            this.userStatsView = new UsersStatisticsView({"venueId": venueId, "from": from, "to": to})
            this.userStatsView.loadData();
        }
        else if(selection == "Counters") {
            /*this.userStatsView = new UsersStatisticsView({"venueId": venueId, "from": from, "to": to})
            this.userStatsView.loadData();*/ //toDo:
        }
        else {
            // toDo: show error message
        }

    },
    changeTabSelect: function(e) {
        this.$el.find("#statistics-container").empty(); // clear currently shown stats
        if(!$("#filter-dates-button").hasClass("display-none"))
            $("#filter-dates-button").addClass("display-none"); // hide "filter period" button, only show if there was a selection between Venue & User

        var $elem = $(e.currentTarget);

        this.statSelectorView = new StatisticsSelectorView({"venueId": $elem.val()});
        this.statSelectorView.render();
    }
});


